export default __webpack_public_path__ + "static/media/ret2.3453fc8d.jpeg";